"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LOGIN_SIGN_UP_BUTTON_TEXT = exports.INPUT_PLACEHOLDER = exports.INPUT_LABEL = exports.FORGOT_PASSWORD_BUTTON_TEXT = exports.EMAIL_INPUT_PLACEHOLDER = exports.EMAIL_INPUT_LABEL = exports.ALREADY_HAVE_APP_LOGIN_TEXT = void 0; // Login Component

var EMAIL_INPUT_LABEL = "Email";
exports.EMAIL_INPUT_LABEL = EMAIL_INPUT_LABEL;
var EMAIL_INPUT_PLACEHOLDER = "Enter Email Here";
exports.EMAIL_INPUT_PLACEHOLDER = EMAIL_INPUT_PLACEHOLDER;
var INPUT_LABEL = "Password";
exports.INPUT_LABEL = INPUT_LABEL;
var INPUT_PLACEHOLDER = "Enter Password Here";
exports.INPUT_PLACEHOLDER = INPUT_PLACEHOLDER;
var FORGOT_PASSWORD_BUTTON_TEXT = "Forgot Password?";
exports.FORGOT_PASSWORD_BUTTON_TEXT = FORGOT_PASSWORD_BUTTON_TEXT;
var ALREADY_HAVE_APP_LOGIN_TEXT = "Already have our app? Log in using the same information above"; // Pages -> Login Component

exports.ALREADY_HAVE_APP_LOGIN_TEXT = ALREADY_HAVE_APP_LOGIN_TEXT;
var LOGIN_SIGN_UP_BUTTON_TEXT = "LOGIN OR SIGN UP!";
exports.LOGIN_SIGN_UP_BUTTON_TEXT = LOGIN_SIGN_UP_BUTTON_TEXT;
var _default = {
  EMAIL_INPUT_LABEL: EMAIL_INPUT_LABEL,
  EMAIL_INPUT_PLACEHOLDER: EMAIL_INPUT_PLACEHOLDER,
  INPUT_LABEL: INPUT_LABEL,
  INPUT_PLACEHOLDER: INPUT_PLACEHOLDER,
  FORGOT_PASSWORD_BUTTON_TEXT: FORGOT_PASSWORD_BUTTON_TEXT,
  ALREADY_HAVE_APP_LOGIN_TEXT: ALREADY_HAVE_APP_LOGIN_TEXT,
  LOGIN_SIGN_UP_BUTTON_TEXT: LOGIN_SIGN_UP_BUTTON_TEXT
};
exports["default"] = _default;